import React, {Component} from 'react'
import { connect } from 'react-redux';
import Switch from 'react-toggle-switch'
import moment from 'moment';
import validator from 'validator';
import sendUsernameVerification from 'controllers/user/sendUsernameVerification'
import getPaymentMethod from 'controllers/payment/getPaymentMethod';
import checkSubscription from 'controllers/payment/checkSubscription';
import changePhone from 'controllers/user/changePhone';
import changeEmail from 'controllers/user/changeEmail';
import changePassword from 'controllers/user/changePassword';
import getUserInfo from 'controllers/user/getUserInfo';
import {clearSchoolDetail} from '../../Main/ducks/school-detail';
import { alert } from 'util/alert'
import PhoneNumber from 'components/Form/Fields/PhoneNumber';
import PlanSubscriptionCard from 'shared/planSubscriptionCard';
import SubscriptionPayment from 'template/Modals/SubscriptionPayment';
import StripePayment from './stripePayment';
import {getSubscription} from '../../Main/ducks/subscription';
import {fetchUserByToken} from '../../Main/ducks/user';
import {SAAS_VERSIONS} from 'data/constants'
import Loading from 'components/UI/Loading';
import isEmpty from 'lodash/isEmpty';
import { isValidUser, isOnlyTeacher } from 'containers/__R';
import './AccountSettings.scss'
import locale from './locale';

const DEFAULT_COUNTRY_CODE = '1'
const DEFAULT_REGION_CODE = 'CA'
const mapStateToProps = (state) => ({
  user: state.user,
  subscription: state.gSubscription,
})
const mapDispatchToProps = dispatch => {
  return {
    getSubscription: () => dispatch(getSubscription()),
    fetchUserByToken: () => dispatch(fetchUserByToken()),
    clearSchoolDetail: () => dispatch(clearSchoolDetail())
  };
};
class AccountSettings extends Component{
  constructor(props){
    super(props)

    this.state = {
      userInfo: {},
      pin: '',
      newEmail: '',
      password: '',
      resend: false,
      counterTime: 59,
      selectedIndex: 0,
      selectedBillCycle: 'yearly',
      showUpdateCard: false,
      currentPaymentMethod: {},
      plansCanBeSubscribed: [],
      currentPlanInfo:{},
      changePhoneNumber: false,
      changeEmail: false,
      changePassword: false,
      showOldPassword: false,
      showNewPassword: false,
      oldPassword: '',
      newPassword: '',
      newPhoneNumber: {country_code: DEFAULT_COUNTRY_CODE, national_number: '', region_code: DEFAULT_REGION_CODE},
      isProcessingPhone: false,
      isProcessingEmail: false,
      isProcessingPassword: false,
      isProcessingCard: false,
      plans: [
        {
          version: 'Basic', 
          monthlyPrice: '30', 
          monthlyPlanCodename:'basic_30usd_monthly',
          yearlyPrice: '27',
          yearlyPlanCodename: 'basic_324usd_yearly',
          studentAmount: 80, 
          teacherAmount: 40, 
          schoolAmount: 1,
          saasVersionMonthly: 3,
          saasVersionYearly: 4
        },
        {
          version: 'Professional', 
          monthlyPrice: '180', 
          monthlyPlanCodename:'professional_180usd_monthly',
          yearlyPrice: '162',
          yearlyPlanCodename: 'professional_1944usd_yearly',
          studentAmount: 500, 
          teacherAmount: 'unlimited', 
          schoolAmount: 5,
          saasVersionMonthly: 5,
          saasVersionYearly: 6
        },
        {
          version: 'Premium', 
          monthlyPrice: '360', 
          monthlyPlanCodename:'premium_360usd_monthly',
          yearlyPrice: '324',
          yearlyPlanCodename: 'premium_3888usd_yearly',
          studentAmount: 1500, 
          teacherAmount: 'unlimited', 
          schoolAmount: 5,
          saasVersionMonthly: 7,
          saasVersionYearly: 8
        }
      ],
      oldVersionPlan: {
        version: 'Discount Plan', 
        monthlyPrice: '79', 
        monthlyPlanCodename:'regular_usd_monthly',
        yearlyPrice: '79',
        yearlyPlanCodename: 'regular_usd_monthly',
        studentAmount: 'unlimited', 
        teacherAmount: 'unlimited', 
        schoolAmount: 1,
        additionalMsg: __('Additional campus costs $79 per month', locale)
      }
    }

    this.onChange = this.onChange.bind(this)
    this.onSelectTab = this.onSelectTab.bind(this);
    this.onPlanChanged = this.onPlanChanged.bind(this);
    this.toggleSwitch = this.toggleSwitch.bind(this);
    this.onPaymentMethodChanged = this.onPaymentMethodChanged.bind(this);
    this.changeUserPhone = this.changeUserPhone.bind(this);
    this.changeUserEmail = this.changeUserEmail.bind(this);
    this.sendVerificationCode = this.sendVerificationCode.bind(this);
    this.changeUserPassword = this.changeUserPassword.bind(this);
  }
  componentWillMount(){
    localStorage.removeItem('SchoolId')
    localStorage.removeItem('role')
    this.props.clearSchoolDetail();
    this.props.getSubscription();
    getUserInfo()
      .then((res)=>{
        if(res){
          this.setState({userInfo: res})
        }
      })
    getPaymentMethod()
      .then((res)=>{
        if(res.result && res.result === 'no payment method'){
          this.setState({currentPaymentMethod: {}});
        }else{
          this.setState({currentPaymentMethod: res[0]});
        }
      })
    checkSubscription()
      .then((res)=>{
        this.setState({plansCanBeSubscribed: res.plans_can_be_subscribed})
      })
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.subscription.result !== this.props.subscription.result){
      let currentVersion= SAAS_VERSIONS[nextProps.subscription.result.saas_version];
      if(currentVersion.billCycle){
        this.setState({selectedBillCycle: currentVersion.billCycle});
      }
      if(currentVersion.planCodename){
        this.setState({currentVersionName: currentVersion.planCodename});
      }
      this.setState({currentPlanInfo: currentVersion})
    }
  }
  onChange(name) {
    return (e)=>{
      this.setState({[name]: e.target.value})
    }
  }
  changeUserPhone(){
    const {newPhoneNumber, pin} = this.state;
    const {fetchUserByToken} = this.props;
    let phoneNumber = newPhoneNumber.country_code+newPhoneNumber.national_number;
    alert.warning(__('Are you sure to change the username?', locale))
    .then((res)=>{
      this.setState({isProcessingPhone: true})
      changePhone({
        phone: phoneNumber,
        code: pin
      })
        .then((res)=>{
          this.setState({isProcessingPhone: false})
          if(res.result==='success'){
            alert.success(__('Account username has been changed successfully!', locale))
            localStorage.setItem('token', res.new_token)
            fetchUserByToken();
            this.setState({
              changePhoneNumber: false, 
              newPhoneNumber: {country_code: DEFAULT_COUNTRY_CODE, national_number: '', region_code: DEFAULT_REGION_CODE},
              pin: ''
            })
          }else{
            let errorMsg = '';
            if(res.reason === 'phone number has been used.'){
              errorMsg=__('This phone number has been used!', locale)
            }else{
              errorMsg=__('Invalid pin!', locale)
            }
            alert.fail(errorMsg, __('Failed to changed account username!', locale))
          }
        })
          .catch((err)=>{
            this.setState({isProcessingPhone: false})
          })
    })
  }
  changeUserPassword(){
    const {oldPassword, newPassword} = this.state;
    alert.warning(__('Are you sure to change the password?', locale))
    .then((res)=>{
      this.setState({isProcessingPassword: true})
      changePassword({
        old_password: oldPassword,
        new_password: newPassword,
        confirm_password: newPassword
      })
        .then((res)=>{
          this.setState({isProcessingPassword: false})
          if(res.result === 'success'){
            alert.success(__('Account password has been changed successfully!', locale));
            this.setState({changePassword: false, oldPassword: '', newPassword: '', showOldPassword: false, showNewPassword: false})
          }else{
            let errorMsg='';
            switch(res.reason){
              case 'old password is wrong':
                errorMsg=__('Invalid current password', locale);
                break;
              case 'new password is too short':
                errorMsg=__('New password is too short', locale);
                break;            
              case 'new password is the same as old one':
                errorMsg= __('New password can not be the same as the current passowrd', locale);
                break;            
              case 'new password is the same as username':
                errorMsg=__('New password can not be the same as the username', locale);
                break;            
              default: 
                return;
            }
            alert.fail(errorMsg, __('Failed to change password!', locale));
          }
        })
          .catch((err)=>{
            this.setState({isProcessingPassword: false})
          })
    })
  }
  onSelectTab(selectedIndex){
    this.setState({selectedIndex})
  }
  onPlanChanged(planCodename, saasVersion){
    const {saas_version} = this.props.subscription.result;
    const {plansCanBeSubscribed, currentPaymentMethod} = this.state;
    let selectedPlanInfo = SAAS_VERSIONS[saasVersion];
    if(plansCanBeSubscribed && plansCanBeSubscribed.includes(planCodename)){
      SubscriptionPayment({currentPaymentMethod, selectedPlanInfo, saasVersion: saas_version})
        .then((res)=>{
          this.props.getSubscription();
          getPaymentMethod()
            .then((res)=>{
              if(res && res.length>0){
                this.setState({currentPaymentMethod: res[0]});
              }
            })
          checkSubscription()
            .then((res)=>{
              this.setState({plansCanBeSubscribed: res.plans_can_be_subscribed})
            })
        })
    }else {
      alert.warning(__('You are unable to subscribe to this plan. If you would like to change, please contact our support team.', locale))
    }
  }

  toggleSwitch(){
    const { selectedBillCycle } = this.state;
    if(selectedBillCycle === 'yearly'){
      this.setState({selectedBillCycle: 'monthly'})
    }else{
      this.setState({selectedBillCycle: 'yearly'})
    }
  }
  setVerificationCounter() {
    this.setState({ resend: true })
    this.timmer = setInterval(() => {
      if (this.state.counterTime > 0) {
        this.setState({ counterTime: (this.state.counterTime - 1) });
      } else {
        this.setState({ resend: false, counterTime: 59 });
        this.clearCounter();
      }
    }, 1000);
  }

  clearCounter() {
    clearInterval(this.timmer);
  }
  changeUserEmail(){
    const { newEmail } = this.state;

    alert.warning(__('Are you sure to change the email?', locale))
      .then((res)=>{
        this.setState({isProcessingEmail: true})
        changeEmail({email: newEmail})
          .then((res)=>{
            this.setState({isProcessingEmail: false})
            if(res.result === 'success'){
              alert.success(__('Email has been changed successfully!', locale));
              getUserInfo()
                .then((res)=>{
                  if(res){
                    this.setState({changeEmail:false, userInfo: res, newEmail: ''})
                  }
                })
            }else{
              alert.fail(__('This email has been used!', locale), __('Failed to change email!', locale))
            }

          })
            .catch((err)=>{
              this.setState({isProcessingEmail: false})
            })
      })
  }
  onPaymentMethodChanged(){
    const {showUpdateCard} = this.state;
    alert.success(__('Credit card info has been updated successfully!', locale))
    getPaymentMethod()
    .then((res)=>{
      if(res && res.length>0){
        this.setState({currentPaymentMethod: res[0]});
      }
      this.setState({showUpdateCard: !showUpdateCard})
    })
  }
  sendVerificationCode(){
    const {newPhoneNumber} = this.state;

    sendUsernameVerification({
      phone: newPhoneNumber.country_code+newPhoneNumber.national_number, 
      check_phone: 'sendIfUserNotExist'
    })
      .then((res) => { 
        if(res.result === 'success'){
          this.setVerificationCounter();
        }else {
          alert.fail(__('Phone number is invalid or has been used', locale), __('Failed to send verification code!', locale))
        }
      })
  }
  renderChangePhone(){
    const {
      changePhoneNumber,
      newPhoneNumber,
      resend,
      counterTime,
      pin,
      isProcessingPhone
    } = this.state
    const {username} = this.props.user.result
    let phoneNumber = newPhoneNumber.country_code+newPhoneNumber.national_number;
    return (
      <div className='phone-setting'>
        { 
          isProcessingPhone &&
          <div className='loading-wrapper'>
            <Loading />
          </div>
        }
        {
          !changePhoneNumber &&
          <div>
            <div>{__('Phone Number', locale)}</div>
            <input type='text' className='form-control' value={username} disabled/>
            <div className="change-btn" onClick={()=>this.setState({changePhoneNumber: true})}>{__('Update Phone Number', locale)}</div>
          </div>
        }
        {
          changePhoneNumber && 
          <div>
            <div>
              <div>{__('Enter New Phone Number', locale)}</div>
              <PhoneNumber defaultCountry={'ca'} value={newPhoneNumber} onChange={(phone)=>{
                this.setState({newPhoneNumber: phone})
              }} />
            </div>

            <div className="verification-wrapper">
              <div>{__('Enter Verification Code', locale)}</div>
              <div className="verification-code">
                <input type='text' className='form-control pin-input' placeholder={__('6 digits', locale)} autoComplete="off" value={pin} onChange={(e)=>this.setState({pin: e.target.value})}/>
                <button className='btn btn-primary btn-no-margin' onClick={this.sendVerificationCode} disabled={resend || phoneNumber.length<6}>
                  {!resend? __("Send Code", 'passwordsettings'): __('Resend in {counterTime} s', 'passwordsettings', {counterTime: counterTime})}
                </button>
              </div>
            </div>
            <button className="btn btn-primary" onClick={this.changeUserPhone} disabled={phoneNumber.length<6 || pin.length<6}>{__('Update', locale)}</button>
          </div>
        }

      </div>
    );
  }
  renderChangeEmail(){
    const {
      changeEmail,
      userInfo,
      newEmail,
      isProcessingEmail
    } = this.state

    return (
      <div className="email-setting">
        { 
          isProcessingEmail &&
          <div className='loading-wrapper'>
            <Loading />
          </div>
        }
        {
          !changeEmail && userInfo &&
          <div>
            <div>{__('Email', locale)}</div>
            <input type='text' className='form-control' value={userInfo.email} disabled/>
            <div className="change-btn" onClick={()=>this.setState({changeEmail: true})}>{__('Update Email', locale)}</div>
          </div>
        }
        {
          changeEmail && 
          <div>
            <div>{__('Enter New Email', locale)}</div>
            <input type='text' className='form-control' autoComplete="off"  placeholder="eg. name@mail.com" value={newEmail} onChange={(e)=>this.setState({newEmail: e.target.value})}/>
            <button className="btn btn-primary" onClick={this.changeUserEmail} disabled={!validator.isEmail(newEmail.trim())}>{__('Update', locale)}</button>
          </div>
        }
      </div>
    );
  }
  renderChangePassword(){
    const {
      changePassword,
      showNewPassword,
      showOldPassword,
      oldPassword,
      newPassword,
      isProcessingPassword
    } = this.state;
    let passwordPlaceholder = '11111111'
    return (
      <div className='password-setting'>
        { 
          isProcessingPassword &&
          <div className='loading-wrapper'>
            <Loading />
          </div>
        }
        {
          !changePassword &&
          <div>
            <div>{__('Password', locale)}</div>
            <input className='form-control' type='password' value={passwordPlaceholder} disabled/>
            <div className="change-btn" onClick={()=>this.setState({changePassword: true})}>{__('Update Password', locale)}</div>
          </div>
        }
        {
          changePassword && 
          <div>
            <div>{__('Enter Current Password', locale)}</div>
            <div className='form-group password'>
              <span className='password-icon'><i className="icon-lock"></i></span>
              <input type={showOldPassword? 'text': 'password'}  autoComplete="off" placeholder={__('At least 6 characters', locale)} className='form-control' value={oldPassword}
                onChange={(e)=>{
                  this.setState({
                    oldPassword: e.target.value,
                  });
                }}
              />
              <span className='toggle-text' onClick={()=>this.setState({showOldPassword: !showOldPassword})}>{showOldPassword? 'hide': 'show'}</span>
            </div>
            <div>{__('Enter New Password', locale)}</div>
            <div className='form-group password'>
              <span className='password-icon'><i className="icon-lock"></i></span>
              <input type={showNewPassword? 'text': 'password'}  autoComplete="off" placeholder={__('At least 6 characters', locale)} className='form-control' value={newPassword}
                onChange={(e)=>{
                  this.setState({
                    newPassword: e.target.value,
                  });
                }}
              />
              <span className='toggle-text' onClick={()=>this.setState({showNewPassword: !showNewPassword})}>{showNewPassword? 'hide': 'show'}</span>
            </div>
            <button className="btn btn-primary" onClick={this.changeUserPassword} disabled={newPassword.trim().length<6 || oldPassword.trim().length<6}>{__('Update', locale)}</button>
          </div>
        }
      </div>
    );
  }
  render(){
    const {saas_version, current_period_end} = this.props.subscription.result;
    const {
      oldVersionPlan, 
      plans, 
      selectedBillCycle, 
      showUpdateCard, 
      currentPaymentMethod, 
      currentVersionName, 
      currentPlanInfo
    } = this.state;
    return(
      <div className="personal-setting-page">
        <h3>{__('Account Settings', locale)}</h3>
        <div className='account-setting'>
          {this.renderChangePhone()}
          {this.renderChangeEmail()}
          {this.renderChangePassword()}
        </div>
        {
          !isEmpty(currentPaymentMethod) && 
          <div className='active-card-section'>
            <h3 className='section-title'>{__('Active Card', locale)}</h3>
            {
              !showUpdateCard && 
              <div>
                <div className="active-card">
                  <div className='card-labels'>
                    <div>{__('Card number', locale)}</div>
                    <div>{__('Expiry date', locale)}</div>
                  </div>
                  <div className='card-details'>
                    <div>**** **** **** {currentPaymentMethod.last4}</div>
                    <div>{currentPaymentMethod.exp_month}/{currentPaymentMethod.exp_year}</div>
                  </div>
                </div>
                <button className="btn btn-primary" onClick={()=>this.setState({showUpdateCard: !showUpdateCard})}>{__('Update Card', locale)}</button>
              </div>
            }
            {
              showUpdateCard && 
              <StripePayment currentPaymentMethod={currentPaymentMethod} onPaymentMethodChanged={this.onPaymentMethodChanged}/>
            }
          </div>
        }
        {
          (isValidUser() || saas_version===0) &&
          <div className='plans-switch-section'>
            <div className='plans-header'>
              <h3 className='section-title'>{__('Account Subscription', locale)}</h3>
              {
                saas_version !==1 &&
                <div className="switch-wrapper">
                  <span className={selectedBillCycle==='monthly'? 'selected' : ''}>{__('Monthly', locale)}</span>
                  <Switch onClick={this.toggleSwitch} on={selectedBillCycle==='yearly'}/>
                  <span className={selectedBillCycle==='yearly'? 'selected' : ''}>{__('Yearly', locale)}</span>
                </div>
              }
            </div>
            <div className='plans-wrapper row'>
              { saas_version !== 1 &&
                plans.map((plan)=>{
                  return <PlanSubscriptionCard key={plan.version} data={plan} billCycle={selectedBillCycle} currentVersionName={currentVersionName} onPlanChanged={this.onPlanChanged} className='switch' />
                })
              }
              {saas_version == 1 &&
                <PlanSubscriptionCard data={oldVersionPlan} billCycle={'monthly'} currentVersionName={currentVersionName} onPlanChanged={this.onPlanChanged} className='switch' />
              }
            </div>
          </div>
        }
          {
            saas_version === 0 && !isOnlyTeacher() &&
            <div className="current-plan">
              <div className='plan-labels'>
                <div>{__('Plan Name', locale)}</div>
                <div>{__('Trial End', locale)}</div>
              </div>
              <div className='plan-details'>
                <div>{__(currentPlanInfo.name, 'settings')}</div>
                <div>{moment(current_period_end).format('YYYY-MM-DD')}</div>
              </div>
            </div>
          }
          {
            saas_version !==0 && !isOnlyTeacher() &&
            <div className="current-plan">
              <div className='plan-labels'>
                <div>{__('Current Plan', locale)}</div>
                <div>{__('Price', locale)}</div>
                <div>{__('Billing Cycle', locale)}</div>
                <div>{__('Next Billing Date', locale)}</div>
              </div>
              <div className='plan-details'>
                <div>{__(currentPlanInfo.name, 'settings')}</div>
                <div>{__('USD', 'settings')}${currentPlanInfo.price}{__('/month', 'settings')}</div>
                <div>{__(currentPlanInfo.billCycle, 'settings')}</div>
                <div>{moment(current_period_end).format('YYYY-MM-DD')}</div>
              </div>
            </div>
          }
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings)



// WEBPACK FOOTER //
// ./src/containers/pages/AccountSettings/index.js